import { HOME } from "constants/routes";
import classes from "./ContactSection.module.css";
import ImageLink from "components/common/Links/ImageLink/ImageLink";
import Logo from "static/logo/logo.svg";

const ContactSection = () => (
  <div className={classes.contactSection}>
    <div className={classes.logo}>
      <ImageLink href={HOME} src={Logo} alt="Logo" />
    </div>
    <p className={classes.phoneNumber}>+48 605 556 858</p>
    <a href="https://wa.me/48605556858" className={classes.phoneNumber}>
      WhatsApp
    </a>
  </div>
);

export default ContactSection;
